<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <loading-spinner :loading="socialLoading" class="text-white"></loading-spinner>
      <div class="row" v-if="!socialLoading">
        <div class="col-12 col-lg-6">
          <b-card header="Login to your account" header-tag="header" no-body>
            <b-card-body class="p-3">
              <h1 class="mx-auto d-block text-center mb-3">DigidoLMS</h1>
              <b-alert variant="danger" dismissible :show="!!error" @dismissed="error=false">
                {{ error }}
              </b-alert>
              <form @submit.prevent="login">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="icon-user"></i></div>
                  </div>
                  <input :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                         v-validate="'required|email'"
                         data-vv-delay="500"
                         data-vv-as="Email"
                         data-vv-name="email"
                         type="text"
                         placeholder="Email"
                         name="email"
                         id="email"
                         autocomplete="email username"
                         v-model.trim="email"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('email')">{{ errors.first('email') }}</div>
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="icon-lock"></i></div>
                  </div>
                  <input :class="{'form-control': true, 'is-invalid': errors.has('password')}"
                         v-validate="'required'"
                         data-vv-delay="500"
                         data-vv-as="Password"
                         data-vv-name="password"
                         type="password"
                         placeholder="Password"
                         name="password"
                         id="password"
                         autocomplete="password"
                         v-model="password"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('password')">{{ errors.first('password') }}</div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <loading-button
                            variant="orange"
                            block
                            class="px-4"
                            :disabled="errors.any()"
                            :loading="loading"
                            type="submit"
                            @submit="login"
                    >
                      Login
                    </loading-button>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col text-center">
                    <h4>- OR -</h4>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <a class="btn btn-block btn-facebook rounded-0 text-white" @click="loginFacebook">
                      <font-awesome-icon :icon="['fab', 'facebook']" class="float-left mt-1"></font-awesome-icon>
                      Login with Facebook
                    </a>
                  </div>
                  <div class="col-12 mt-3">
                    <a class="btn btn-block btn-google-plus rounded-0 text-white" @click="loginGoogle">
                      <font-awesome-icon :icon="['fab', 'google-plus']" class="float-left mt-1"></font-awesome-icon>
                      Login with Google
                    </a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <router-link to="/login/forgot" class="float-right">
                      Forgot your password?
                    </router-link>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
        <div class="col-lg-6 d-md-down-none text-white">
          <h2>Welcome to the<br><b>DIGIDO LEARNING SYSTEM</b></h2><br>
          <h4>Our approach to training is different from the conventional models being used elsewhere in the flooring industry. Our proven training streams cater to all levels of learning - from apprentice to master installer. Log-in to begin learning today.</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueJsModal from 'vue-js-modal/src/Modal'

export default {
  name: 'Login',
  components: { VueJsModal },
  data () {
    return {
      email: '',
      password: '',
      error: '',
      loading: false,
      socialLoading: false
    }
  },
  methods: {
    login () {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.error = null
          this.loading = true
          let redirect = this.$auth.redirect();
          this.$auth.login({
            data: { email: this.email, password: this.password },
            fetchUser: true,
            redirect: { path: redirect ? redirect.from.path : "/dashboard" },
          }).catch(error => {
            this.loading = false
            this.error = error.response.data.message
          })
        }
      })
    },
    loginFacebook () {
      this.$auth.oauth2({
        provider: 'facebook',
        rememberMe: true,
        params: {
          'app_id': this.$config.FACEBOOK_CLIENT_ID,
          'client_id': this.$config.FACEBOOK_CLIENT_ID
        }
      })
    },
    loginGoogle () {
      this.$auth.oauth2({
        provider: 'google',
        rememberMe: true,
        params: {
          'client_id': this.$config.GOOGLE_CLIENT_ID
        }
      })
    }
  },
  mounted () {
    if (this.$route.query.code) {
      this.socialLoading = true
      this.$auth.oauth2({
        code: true,
        provider: this.provider,
        data: {
          code: this.$route.query.code
        },
        success: () => {
          this.$swal('Success', 'Logged in Successfully', 'success')
        },
        error: (res) => {
          this.socialLoading = false
          this.$swal('Error', res.response.data.message, 'error')
        },
        redirect: '/dashboard'
      })
    }
  },
  metaInfo: {
    title: 'Login'
  },
  props: ['provider']
}
</script>

<style lang="scss">
  .page-login {
    background: url("../../assets/img/login_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    color: black;
  }
</style>
